import { render, staticRenderFns } from "./salesTableFhx.vue?vue&type=template&id=7c126b78"
import script from "./salesTableFhx.vue?vue&type=script&lang=js"
export * from "./salesTableFhx.vue?vue&type=script&lang=js"
import style0 from "./salesTableFhx.vue?vue&type=style&index=0&id=7c126b78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports